import { GraphQLClient } from "graphql-request";

export default function graphqlClient(csrfToken) {
  return new GraphQLClient("/graphql", {
    headers: {
      "X-CSRF-Token": csrfToken,
    },
  });
}
